(function () {
  const STORAGE_DISMISSED = 'chutty_popup_dismissed';
  const STORAGE_SUBSCRIBED = 'chutty_popup_subscribed';
  const STORAGE_SHOW_COUPON = 'chutty_popup_show_coupon';

  /**
   * @param {string} name
   * @returns {string | null}
   */
  function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  }

  /**
   * @param {string} name
   * @param {string} value
   * @param {number} days
   */
  function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 86400000).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
  }

  const MONTH_NAMES = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  /**
   * @param {string} isoDate
   * @returns {string}
   */
  function formatDateForNote(isoDate) {
    const parts = isoDate.split('-');
    if (parts.length !== 3) return isoDate;
    const [year, month, day] = parts;
    return `${day}/${month}/${year}`;
  }

  /**
   * @param {number} year
   * @param {number} month
   * @param {number} day
   * @returns {string}
   */
  function toIsoDate(year, month, day) {
    return `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
  }

  /**
   * @param {HTMLFormElement} form
   */
  function initDateFields(form) {
    form.querySelectorAll('[data-chutty-popup-date-field]').forEach((field) => {
      if (!(field instanceof HTMLElement)) return;

      const display = field.querySelector('[data-chutty-popup-date-display]');
      const valueInput = field.querySelector('[data-chutty-popup-baby-dob]');
      const trigger = field.querySelector('[data-chutty-popup-date-trigger]');
      const calendar = field.querySelector('[data-chutty-popup-calendar]');
      const monthSelect = field.querySelector('[data-chutty-popup-calendar-month]');
      const yearSelect = field.querySelector('[data-chutty-popup-calendar-year]');
      const daysGrid = field.querySelector('[data-chutty-popup-calendar-days]');

      if (
        !(display instanceof HTMLInputElement) ||
        !(valueInput instanceof HTMLInputElement) ||
        !(calendar instanceof HTMLElement) ||
        !(monthSelect instanceof HTMLSelectElement) ||
        !(yearSelect instanceof HTMLSelectElement) ||
        !(daysGrid instanceof HTMLElement)
      ) {
        return;
      }

      const popupRoot = field.closest('[data-chutty-popup]');
      if (popupRoot instanceof HTMLElement && calendar.parentElement !== popupRoot) {
        popupRoot.appendChild(calendar);
      }

      const today = new Date();
      const startYear = today.getFullYear() - 20;
      const endYear = today.getFullYear() + 1;
      let viewYear = today.getFullYear();
      let viewMonth = today.getMonth();

      if (!monthSelect.options.length) {
        MONTH_NAMES.forEach((name, index) => {
          const option = document.createElement('option');
          option.value = String(index);
          option.textContent = name;
          monthSelect.appendChild(option);
        });
      }

      if (!yearSelect.options.length) {
        for (let year = endYear; year >= startYear; year -= 1) {
          const option = document.createElement('option');
          option.value = String(year);
          option.textContent = String(year);
          yearSelect.appendChild(option);
        }
      }

      /**
       * @returns {boolean}
       */
      function isOpen() {
        return !calendar.hasAttribute('hidden');
      }

      function positionCalendar() {
        const rect = field.getBoundingClientRect();
        const calendarHeight = calendar.offsetHeight || 300;
        const spaceBelow = window.innerHeight - rect.bottom;
        calendar.style.left = `${Math.max(16, Math.min(rect.left, window.innerWidth - 296))}px`;
        calendar.style.width = `${Math.min(280, rect.width)}px`;

        if (spaceBelow < calendarHeight + 12) {
          calendar.style.top = 'auto';
          calendar.style.bottom = `${window.innerHeight - rect.top + 8}px`;
        } else {
          calendar.style.bottom = 'auto';
          calendar.style.top = `${rect.bottom + 8}px`;
        }
      }

      function renderDays() {
        const firstDay = new Date(viewYear, viewMonth, 1).getDay();
        const daysInMonth = new Date(viewYear, viewMonth + 1, 0).getDate();
        const selected = valueInput.value;
        daysGrid.replaceChildren();

        for (let i = 0; i < firstDay; i += 1) {
          const empty = document.createElement('span');
          empty.className = 'chutty-popup__calendar-day is-empty';
          daysGrid.appendChild(empty);
        }

        for (let day = 1; day <= daysInMonth; day += 1) {
          const iso = toIsoDate(viewYear, viewMonth, day);
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'chutty-popup__calendar-day';
          button.textContent = String(day);
          button.dataset.date = iso;
          if (iso === selected) button.classList.add('is-selected');
          daysGrid.appendChild(button);
        }
      }

      function syncView() {
        monthSelect.value = String(viewMonth);
        yearSelect.value = String(viewYear);
        renderDays();
      }

      function closeCalendar() {
        calendar.hidden = true;
        trigger?.setAttribute('aria-expanded', 'false');
      }

      function openCalendar() {
        if (valueInput.value) {
          const parts = valueInput.value.split('-');
          if (parts.length === 3) {
            viewYear = Number(parts[0]);
            viewMonth = Number(parts[1]) - 1;
          }
        }

        calendar.hidden = false;
        trigger?.setAttribute('aria-expanded', 'true');
        syncView();
        positionCalendar();
      }

      function toggleCalendar() {
        if (isOpen()) {
          closeCalendar();
          return;
        }
        openCalendar();
      }

      display.addEventListener('click', toggleCalendar);
      trigger?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        toggleCalendar();
      });

      monthSelect.addEventListener('change', () => {
        viewMonth = Number(monthSelect.value);
        renderDays();
      });

      yearSelect.addEventListener('change', () => {
        viewYear = Number(yearSelect.value);
        renderDays();
      });

      daysGrid.addEventListener('click', (event) => {
        const button = event.target instanceof Element ? event.target.closest('[data-date]') : null;
        if (!(button instanceof HTMLButtonElement) || !button.dataset.date) return;

        valueInput.value = button.dataset.date;
        display.value = formatDateForNote(button.dataset.date);
        field.classList.add('is-filled');
        closeCalendar();
      });

      document.addEventListener('click', (event) => {
        if (!isOpen()) return;
        if (event.target instanceof Node && field.contains(event.target)) return;
        if (event.target instanceof Node && calendar.contains(event.target)) return;
        closeCalendar();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && isOpen()) closeCalendar();
      });

      window.addEventListener('resize', () => {
        if (isOpen()) positionCalendar();
      });
    });
  }

  /**
   * @param {HTMLElement} popup
   */
  function initPopup(popup) {
    if (popup.dataset.initialized === 'true') return;
    popup.dataset.initialized = 'true';

    const isDesignMode = popup.dataset.designMode === 'true';
    const delay = Number(popup.dataset.delay || 5000);
    const cookieDays = Number(popup.dataset.cookieDays || 7);
    const exitIntent = popup.dataset.exitIntent === 'true';
    const skipSubscribed = popup.dataset.skipSubscribed === 'true';

    const closeButtons = popup.querySelectorAll('[data-chutty-popup-close]');
    const formPanel = popup.querySelector('[data-chutty-popup-form-panel]');
    const successPanel = popup.querySelector('[data-chutty-popup-success-panel]');
    const form = popup.querySelector('.chutty-popup__form');
    const errorEl = popup.querySelector('[data-chutty-popup-error]');
    const submitBtn = popup.querySelector('[data-chutty-popup-submit]');

    let hasOpened = false;
    let exitIntentShown = false;

    /**
     * @returns {boolean}
     */
    function shouldSkip() {
      if (isDesignMode) return false;
      if (skipSubscribed && getCookie(STORAGE_SUBSCRIBED) === '1') return true;
      if (getCookie(STORAGE_DISMISSED) === '1') return true;
      return false;
    }

    /**
     * @param {{ preview?: boolean }} [options]
     */
    function openPopup(options = {}) {
      const preview = options.preview === true || isDesignMode;
      if (!preview && (hasOpened || shouldSkip())) return;

      hasOpened = true;
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('chutty-popup-open');

      if (preview && formPanel && successPanel?.hasAttribute('hidden') === false) {
        successPanel.setAttribute('hidden', '');
        formPanel.removeAttribute('hidden');
      }

      const firstInput = form?.querySelector('input:not([type="hidden"])');
      if (firstInput instanceof HTMLElement) {
        setTimeout(() => firstInput.focus(), 350);
      }
    }

    /**
     * @param {boolean} subscribed
     */
    function closePopup(subscribed = false) {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('chutty-popup-open');

      if (isDesignMode) return;

      if (subscribed) {
        setCookie(STORAGE_SUBSCRIBED, '1', 365);
      } else {
        setCookie(STORAGE_DISMISSED, '1', cookieDays);
      }
    }

    function showSuccess() {
      formPanel?.setAttribute('hidden', '');
      successPanel?.removeAttribute('hidden');
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('chutty-popup-open');
      if (!isDesignMode) {
        setCookie(STORAGE_SUBSCRIBED, '1', 365);
        try {
          sessionStorage.setItem(STORAGE_SHOW_COUPON, '1');
        } catch {
          /* ignore */
        }
      }
    }

    closeButtons.forEach((button) => {
      button.addEventListener('click', () => closePopup(false));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && popup.classList.contains('is-open')) {
        closePopup(false);
      }
    });

    /**
     * @param {HTMLFormElement} form
     */
    function fillCustomerNote(form) {
      const noteInput = form.querySelector('[data-chutty-popup-note]');
      const babyNameInput = form.querySelector('[data-chutty-popup-baby-name]');
      const babyDobInput = form.querySelector('[data-chutty-popup-baby-dob]');

      if (!(noteInput instanceof HTMLInputElement)) return;

      const noteParts = [];

      if (babyNameInput instanceof HTMLInputElement && babyNameInput.value.trim()) {
        noteParts.push(`Baby's Name: ${babyNameInput.value.trim()}`);
      }

      if (babyDobInput instanceof HTMLInputElement && babyDobInput.value.trim()) {
        noteParts.push(`Baby's Date of Birth: ${formatDateForNote(babyDobInput.value.trim())}`);
      }

      noteInput.value = noteParts.join('\n');
    }

    /**
     * @param {HTMLFormElement} form
     * @returns {boolean}
     */
    function validatePopupForm(form) {
      const emailInput = form.querySelector('input[name="contact[email]"]');
      const nameInput = form.querySelector('input[name="contact[first_name]"]');

      if (nameInput instanceof HTMLInputElement && nameInput.required && !nameInput.value.trim()) {
        nameInput.focus();
        return false;
      }

      if (!(emailInput instanceof HTMLInputElement) || !emailInput.value.trim() || !emailInput.checkValidity()) {
        emailInput?.focus();
        return false;
      }

      return true;
    }

    /**
     * @param {HTMLFormElement} form
     */
    function saveCustomerInBackground(form) {
      const formData = new FormData(form);
      formData.delete('return_to');
      if (!formData.get('form_type')) formData.set('form_type', 'customer');
      if (!formData.get('utf8')) formData.set('utf8', '✓');

      const contactUrl = (form.getAttribute('action') || '/contact').split('#')[0];

      fetch(contactUrl, {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      }).catch(() => {
        /* Coupon is already shown; Shopify save is best-effort. */
      });
    }

    /**
     * @param {HTMLFormElement} form
     */
    function claimDiscount(form) {
      if (!(submitBtn instanceof HTMLButtonElement) || submitBtn.disabled) return;
      if (!validatePopupForm(form)) return;

      fillCustomerNote(form);
      errorEl?.setAttribute('hidden', '');
      submitBtn.disabled = true;
      showSuccess();
      saveCustomerInBackground(form);
    }

    if (form instanceof HTMLFormElement) {
      initDateFields(form);
      form.setAttribute('novalidate', '');
      form.querySelectorAll('input[name="return_to"]').forEach((input) => input.remove());

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        claimDiscount(form);
      });

      submitBtn?.addEventListener('click', (event) => {
        event.preventDefault();
        claimDiscount(form);
      });

      form.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter') return;
        if (event.target instanceof HTMLTextAreaElement) return;
        event.preventDefault();
        claimDiscount(form);
      });
    }

    const successCta = popup.querySelector('[data-chutty-popup-success-cta]');
    successCta?.addEventListener('click', () => closePopup(true));

    const copyButton = popup.querySelector('[data-chutty-popup-coupon-copy]');
    const copyLabel = popup.querySelector('[data-chutty-popup-coupon-copy-label]');
    const couponCode = popup.querySelector('[data-chutty-popup-coupon-code]');

    /**
     * @param {string} code
     * @returns {boolean}
     */
    function copyWithSelection(code) {
      const source = couponCode instanceof HTMLInputElement ? couponCode : null;
      const target = source || document.createElement('input');

      if (!source) {
        target.value = code;
        target.setAttribute('readonly', '');
        target.style.cssText = 'position:fixed;top:1px;left:1px;width:1px;height:1px;padding:0;border:0;';
        document.body.appendChild(target);
      }

      target.focus();
      target.select();
      target.setSelectionRange(0, code.length);

      let copied = false;
      try {
        copied = document.execCommand('copy');
      } catch {
        copied = false;
      }

      if (!source) target.remove();
      return copied;
    }

    /**
     * @param {string} code
     * @returns {Promise<boolean>}
     */
    async function copyDiscountCode(code) {
      try {
        if (navigator.clipboard?.writeText && window.isSecureContext) {
          await navigator.clipboard.writeText(code);
          return true;
        }
      } catch {
        /* Use the visible input fallback next. */
      }

      return copyWithSelection(code);
    }

    copyButton?.addEventListener('click', async (event) => {
      event.preventDefault();
      const code = (couponCode instanceof HTMLInputElement ? couponCode.value : couponCode?.textContent || '').trim();
      if (!code) return;

      const copied = await copyDiscountCode(code);

      if (copied) {
        copyButton.classList.add('is-copied');
        if (copyLabel) copyLabel.textContent = 'Copied';
        window.setTimeout(() => {
          copyButton.classList.remove('is-copied');
          if (copyLabel) copyLabel.textContent = 'Copy';
        }, 1800);
        return;
      }

      if (couponCode instanceof HTMLInputElement) {
        couponCode.focus();
        couponCode.select();
      }
      if (copyLabel) copyLabel.textContent = 'Copy';
    });

    if (isDesignMode) {
      openPopup({ preview: true });
      return;
    }

    try {
      if (sessionStorage.getItem(STORAGE_SHOW_COUPON) === '1') {
        sessionStorage.removeItem(STORAGE_SHOW_COUPON);
        openPopup({ preview: true });
        showSuccess();
        return;
      }
    } catch {
      /* ignore */
    }

    if (shouldSkip()) return;

    setTimeout(() => openPopup(), delay);

    if (exitIntent) {
      document.addEventListener('mouseout', (event) => {
        if (exitIntentShown || hasOpened) return;
        if (!(event instanceof MouseEvent)) return;
        if (event.clientY > 12) return;
        if (event.relatedTarget || event.toElement) return;

        exitIntentShown = true;
        openPopup();
      });
    }
  }

  let previewControlsBound = false;

  function bindPreviewControls() {
    if (previewControlsBound) return;
    previewControlsBound = true;

    document.addEventListener('click', (event) => {
      const button = event.target instanceof Element ? event.target.closest('[data-chutty-popup-preview]') : null;
      if (!(button instanceof HTMLButtonElement)) return;

      const targetId = button.dataset.chuttyPopupTarget;
      if (!targetId) return;

      const popup = document.getElementById(targetId);
      if (!(popup instanceof HTMLElement)) return;

      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('chutty-popup-open');

      const formPanel = popup.querySelector('[data-chutty-popup-form-panel]');
      const successPanel = popup.querySelector('[data-chutty-popup-success-panel]');
      formPanel?.removeAttribute('hidden');
      successPanel?.setAttribute('hidden', '');
    });
  }

  function boot() {
    document.querySelectorAll('[data-chutty-popup]').forEach((popup) => {
      if (popup instanceof HTMLElement) initPopup(popup);
    });
  }

  bindPreviewControls();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
